import { useState } from 'react';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';

/**
 * @name useWindowSize
 * @description A React hook that listens to window size.
 * @returns {object} { width, height }
 */

interface WindowSize {
    width: number;
    height: number;
}

export function useWindowSize(): WindowSize {
    const [windowSize, setWindowSize] = useState<WindowSize>({
        width: 0,
        height: 0,
    });

    const handleSize = () => {
        setWindowSize({
            width: Math.min(window.innerWidth, document.documentElement.clientWidth),
            height: Math.min(window.innerHeight, document.documentElement.clientHeight),
        });
    };

    useIsomorphicLayoutEffect(() => {
        window.addEventListener('resize', handleSize, false);
        handleSize();

        return () => window.removeEventListener('resize', handleSize, false);
    }, []);

    return windowSize;
}
